import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { GenericListProps } from "../../types/GenericListType";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { Links, LinksProps } from "../../components/Links";
import { GroupedComponents } from "../../components/GroupedComponents";

export interface GasMainsRelocationPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  processes?: ProcessStepsProps[];
  faqs?: FaqAccordionGroupProps;
  wantToReport?: GreyCardProps;
  linksList?: LinksProps[];
}

export const GasMainsRelocationPage: React.FC<GasMainsRelocationPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  processes,
  wantToReport,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {lists && lists[0] && <List {...lists[0]} />}
      <GroupedComponents>
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
        {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      </GroupedComponents>
      {processes && processes[1] && <ProcessSteps {...processes[1]} />}
      {lists && lists[1] && <List {...lists[1]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
